export default __webpack_public_path__ + "static/media/BN.7980b3a9.svg";